import { module } from 'angular';

import Circuit from './circuit/circuit.module.ajs';
import Lync from './lync/lync.module.ajs';
import Osv from './osv/osv.module.ajs';
import Skype from './skype/skype.module.ajs';

export default module('contact.agent.core.channel-digit.softphone', [Circuit, Lync, Osv, Skype]).name;
